import React from 'react'
import IcoMoon from 'react-icomoon'
const iconSet = require('src/assets/fonts/selection.json')

export const B2Icons = ({ ...props }) => {
  return <IcoMoon iconSet={iconSet} {...props} />
}
